import { useMemo } from "react"

import createStore from "@Stores/base-factories"

const useSubIdFactory = ({ fetch, collections: { collectionsURL } }) => useMemo(() => ({
  saveBulk: async (payload, params) => {
    const { ok } = await fetch({
      url: `${collectionsURL}/bulk`,
      method: 'post',
      data: payload,
      params,
    })

    return ok
  },
}), [collectionsURL, fetch])

const { Provider, useStore } = createStore()
  .extendHookCollectionFactory('subid')
  .extendHookCollectionsFactory('subids')
  .extend(useSubIdFactory)
  .factory()

export {
  Provider as SubidProvider,
  useStore as useSubIdStore,
}
